var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Registration Type"}},[_c('vue-apex-charts',{attrs:{"type":"pie","options":_vm.pieChart.chartOptions,"series":_vm.pieChart.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }